export default __webpack_public_path__ + "static/media/complementary--chevron-right--g2.71ba8ac6.png";